import { Link } from "react-router-dom";
import { ArrowLeft, Clock, Sparkles } from "lucide-react";
import { getImageUrl } from "../lib/imageUtils";

const CategoryItem = ({ category }) => {
	if (category.comingSoon) {
		return (
			<div className="group relative overflow-hidden rounded-2xl shadow-2xl transition-all duration-500 cursor-not-allowed opacity-75 floating-card water-drop bubble-container"
			style={{
				borderColor: 'rgba(255, 165, 0, 0.3)',
				'--tw-shadow-color': 'rgba(255, 165, 0, 0.2)',
			}}>
				{/* Background Image */}
				<div className="relative h-64 bg-gradient-to-br from-gray-800 to-gray-900">
					<div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
					<img 
						src={getImageUrl(category.imageUrl)}
						alt={category.name}
						className="absolute inset-0 w-full h-full object-cover opacity-30"
					/>
					
					{/* Coming Soon Badge */}
					<div className="absolute top-4 right-4 bg-orange-500 text-white px-3 py-1 rounded-full text-xs font-bold animate-pulse">
						🔄 בקרוב
					</div>
				</div>
				
				{/* Content */}
				<div className="absolute bottom-0 left-0 right-0 p-6 text-white">
					<div className="flex items-center justify-between mb-2">
						<h3 className="text-xl font-bold group-hover:text-yellow-300 transition-colors duration-300">
							{category.icon} {category.name}
						</h3>
						<Clock className="text-orange-400" size={20} />
					</div>
					<p className="text-gray-300 text-sm mb-3">
						טרם הגיע המלאי - נודיע בהודעה כשיגיע!
					</p>
					<div className="flex items-center text-orange-400 text-sm font-medium">
						<span>מוקדש במלוא תשומת הלב...</span>
						<Sparkles className="mr-2" size={16} />
					</div>
				</div>
			</div>
		);
	}

	return (
		<Link
			to={category.href}
			className="group relative overflow-hidden rounded-2xl shadow-2xl transition-all duration-500 transform hover:scale-105 floating-card water-drop bubble-container floating-with-bubbles"
			style={{
				borderColor: 'rgba(100, 13, 19, 0.2)',
				'--tw-shadow-color': 'rgba(100, 13, 70, 0.2)',
			}}
			onMouseEnter={(e) => {
				e.currentTarget.style.borderColor = 'rgba(100, 13, 33, 0.4)';
				e.currentTarget.style.boxShadow = `0 25px 50px -12px rgba(100, 13, 70, 0.2)`;
			}}
			onMouseLeave={(e) => {
				e.currentTarget.style.borderColor = 'rgba(100, 13, 22, 0.2)';
				e.currentTarget.style.boxShadow = '';
			}}
		>
			{/* Bubbles */}
			<div className="bubble"></div>
			<div className="bubble"></div>
			<div className="bubble"></div>
			<div className="bubble"></div>
			<div className="bubble"></div>
			
			<div className="relative h-[40vh] mt-[-30px] mb-[-30px] aspect-square w-full flex items-center justify-center">
				<img
					src={getImageUrl(category.imageUrl)}
					alt={category.name}
					className="w-full h-full object-cover transition-all duration-700 group-hover:scale-105 group-hover:rotate-3"
					onError={(e) => {
						e.target.src = '/placeholder.jpg';
					}}
				/>
				
				{/* Gradient Overlay */}
				<div className="absolute inset-0 bg-gradient-to-t from-waith/60 via-black/40 to-transparent group-hover:from-waith/50 group-hover:via-black/30 transition-all duration-300"></div>
				{/* <div className="absolute "></div> */}
				
				{/* Content */}
				<div className="absolute inset-0 flex flex-col justify-center items-center text-center p-6">
					{/* Badge */}
					{category.comingSoon && (
						<div className="absolute top-4 left-4 bg-gradient-to-r from-yellow-500 to-orange-500 text-white px-3 py-1 rounded-full text-xs font-bold shadow-lg">
							<Clock className="w-3 h-3 inline ml-1" />
							בקרוב
						</div>
					)}
					
					{!category.comingSoon && (category.productCount > 0 || category.count) && (
						<div className="absolute top-4 left-4 bg-gradient-to-r from-emerald-500 to-teal-500 text-white px-3 py-1 rounded-full text-xs font-bold shadow-lg">
							<Sparkles className="w-3 h-3 inline ml-1" />
							{category.count || `${category.productCount} מוצרים`}
						</div>
					)}
					
					<h3 className="text-3xl font-bold text-white mb-3 group-hover:text-brand-primary transition-colors duration-300">
						{category.name}
					</h3>
					
					{category.comingSoon ? (
						<>
							<p className="text-white/90 text-sm mb-4 leading-relaxed">
								קולקציה חדשה בדרך אליכם
							</p>
							<div className="px-6 py-3 bg-gradient-to-r from-yellow-500/90 to-orange-500/90 backdrop-blur-sm rounded-full text-white font-bold text-sm group-hover:from-yellow-400 group-hover:to-orange-400 transition-all duration-300 shadow-lg">
								בקרוב זמין
							</div>
						</>
					) : (
						<>
							<p className="text-white/90 text-sm mb-4 leading-relaxed">
								גלה את הקולקציה הייחודית שלנו
							</p>
							<div className="flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-white/20 to-white/10 backdrop-blur-sm rounded-full text-white font-bold text-sm group-hover:from-white/30 group-hover:to-white/20 transition-all duration-300 shadow-lg border border-white/20">
								<span>גלה עכשיו</span>
								<ArrowLeft className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" />
							</div>
						</>
					)}
				</div>
				
				{/* Hover Effect */}
				<div className="absolute inset-0 bg-gradient-to-t from-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" style={{background: 'linear-gradient(to top, rgba(100, 13, 70, 0.2), transparent)'}}></div>
			</div>
		</Link>
	);
};

export default CategoryItem;
